export default {
  ui: {},

	infos: {
		page: 2,
		per_page: 2,
		subtotal: null,
		total: null,
		type: null,
		query: null,
    tag: null,
    year: null,
  },
  
	init() {
		this.bindUI();
		this.bindEvents();
		this.initAjax();
	},

  bindUI() {
    this.ui.btn  = document.querySelector('.js-ajax-btn');
    this.ui.list = document.querySelector('.js-ajax-list');
    this.ui.links = document.querySelector('.js-links');
    this.ui.years = this.ui.links.querySelectorAll('a');
    this.ui.yearsmobile = this.ui.links.querySelector('select');
	},

	bindEvents() {
    this.ui.btn.addEventListener('click', this.loadPosts.bind(this));

    for (let i = 0, j = this.ui.years.length; i < j; i++) {
			this.ui.years[i].addEventListener('click', this.loadPostByYear.bind(this));
    }
    
    this.ui.yearsmobile.addEventListener('change', this.loadPostByYearMobile.bind(this));
  },

	initAjax() {
		// Update subtotal current value.
    this.infos.subtotal = this.infos.per_page;
  },
  
	loadPosts(e) {
		// Prevent default.
		e.preventDefault();
		// Get btn href.
		const href = this.ui.btn.getAttribute('href');
		// If type is null, save it.
    if (!this.infos.type) 
      {this.infos.type = this.ui.btn.getAttribute('data-type');}
    if (!this.infos.year) 
      {this.infos.year = this.ui.btn.getAttribute('data-year');}
		// Add is-loading class on btn.
    this.ui.btn.classList.add('is-loading');
  
		// Create ajax call.
    this.ajaxGet(href);
  },

  loadPostByYear(e) {
    // Prevent default.
    e.preventDefault();
    
    const el = e.target;

		// Get item.
    const item = el.closest('a');

    for (let i = 0, j = this.ui.years.length; i < j; i++) {
			this.ui.years[i].classList.remove('is-active');
		}

    // Toggle class on item.
    item.classList.add('is-active');

    this.infos.year = item.textContent;
    this.infos.page = 1;
    this.infos.subtotal = null;
		this.infos.total = null;
    
    const geturl = `/wp-json/wp/v2/postsbyyear/${this.infos.year}/?page=1&per_page=${this.infos.per_page}`;

    // Add is-loading class on btn.
    this.ui.btn.parentNode.classList.remove('is-hidden');
    this.ui.btn.classList.add('is-loading');
    
    // Clear posts.
    this.ui.list.innerHTML = '';

		// Create ajax call.
    this.ajaxGet(geturl);
  },

  loadPostByYearMobile(e) {

    const el = e.target;

		// Get item.
    let item = el.closest('select');

    this.infos.year = parseInt(item.value);

    this.infos.page = 1;
    this.infos.subtotal = null;
		this.infos.total = null;
    
    const geturl = `/wp-json/wp/v2/postsbyyear/${this.infos.year}/?page=1&per_page=${this.infos.per_page}`;

    // Add is-loading class on btn.
    this.ui.btn.parentNode.classList.remove('is-hidden');
    this.ui.btn.classList.add('is-loading');
    
    // Clear posts.
    this.ui.list.innerHTML = '';

		// Create ajax call.
    this.ajaxGet(geturl);
  },

  
	ajaxGet(url) {

		const self = this;
		// Init request.
		const xmlhttp = new XMLHttpRequest();
		// Bind state change for request.
    xmlhttp.onreadystatechange = function() {
      // If succes.
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
            try {
              // Save data.
              const data = JSON.parse(xmlhttp.responseText);

              // If total is null, save it.
              if (!self.infos.total) self.infos.total = data[0].total_posts;
               
              // Build results.
              self.resultsHandler(data);
            } catch(err) {
                console.log(err.message + ' in ' + xmlhttp.responseText);
                return;
            }
        }
    };
    xmlhttp.open('GET', url, true);
    xmlhttp.send();
  },
  
	resultsHandler(data) {

		// Build articles.
    this.buildPosts(data);
    
		// Increment page.
    this.infos.page++;
		// Increment subtotal.
    this.infos.subtotal += this.infos.per_page;

		// If there is no more article.
		if (this.infos.subtotal >= this.infos.total) {
      this.ui.btn.parentNode.classList.add('is-hidden');
		} else {
			if (this.infos.type == 'post') {
				this.ui.btn.setAttribute('href', `/wp-json/wp/v2/postsbyyear/${this.infos.year}/?page=${this.infos.page}&per_page=${this.infos.per_page}`);
			}
    }
		// Update btn.
		this.updateBtn();
  },
  
	buildPosts(data) {
		// Init content string.
		let content = '';
		// Loop through each data.
		for (let i = 0, j = data.length; i < j; i++) {
			// Get element.
			const el = data[i];
			// Add all posts.
			content += this.createPost(el);
		}
		// Append content inside list.
		this.ui.list.innerHTML = this.ui.list.innerHTML + content;
  },
  
	createPost(post) {
    let markup = 
			`<article class="article">
        <div class="row">`;

        if (post.post_thumbnail != '') {
          markup += `<div class="col-12 col-sm-12 offset-sm-0 col-md-12 offset-md-0 col-lg-8 offset-lg-2">
            <div class="thumbnail position-relative">${post.post_thumbnail}</div>
          </div>`;
        }
          
        markup += `<div class="col-12 col-sm-12 offset-sm-0 col-md-2 offset-md-0 col-lg-2 offset-lg-2">
            <div class="day">${post.date_day}</div>
            <div class="month">${post.date_month}</div>
            <div class="year">${post.date_year}</div>
            <div class="share">
              <div class="share-icon twitter icon-twitter"><svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12.5" r="12" stroke="#BDBDBD"/><path d="M18.5512 8.66429C18.2735 8.78273 17.9852 8.87617 17.6893 8.94382C18.0153 8.64591 18.2604 8.27328 18.3987 7.85736C18.4381 7.73863 18.304 7.63595 18.1926 7.69953C17.781 7.93431 17.3377 8.11043 16.8749 8.22307C16.8481 8.22961 16.8204 8.23292 16.7926 8.23292C16.7083 8.23292 16.6263 8.20282 16.5619 8.14818C16.0695 7.73083 15.4362 7.50098 14.7787 7.50098C14.4943 7.50098 14.207 7.54362 13.925 7.62775C13.0512 7.8884 12.3769 8.58163 12.1654 9.43692C12.086 9.75772 12.0646 10.0788 12.1015 10.3913C12.1057 10.4272 12.0881 10.4522 12.0772 10.464C12.0581 10.4846 12.031 10.4964 12.0029 10.4964C11.9997 10.4964 11.9965 10.4963 11.9933 10.496C10.0806 10.3251 8.35572 9.43879 7.13651 8.00046C7.07434 7.92709 6.95512 7.93609 6.90556 8.01784C6.66681 8.41178 6.54064 8.86234 6.54064 9.32082C6.54064 10.0235 6.83416 10.6856 7.344 11.1683C7.1296 11.1194 6.92208 11.0424 6.72932 10.9395C6.63606 10.8896 6.52132 10.9537 6.52001 11.0563C6.50666 12.1001 7.14209 13.0289 8.09399 13.4471C8.07482 13.4475 8.05565 13.4478 8.03645 13.4478C7.88556 13.4478 7.73278 13.4337 7.58241 13.4061C7.47739 13.3868 7.38916 13.4826 7.42177 13.5806C7.73074 14.5083 8.56128 15.1921 9.55517 15.3473C8.7303 15.8799 7.76972 16.1608 6.76995 16.1608L6.45826 16.1606C6.36223 16.1606 6.28101 16.2208 6.25654 16.3103C6.23243 16.3984 6.27684 16.4913 6.35873 16.5372C7.48532 17.1677 8.77035 17.501 10.0755 17.501C11.2179 17.501 12.2865 17.2829 13.2517 16.8529C14.1365 16.4587 14.9184 15.8953 15.5756 15.1781C16.1879 14.5101 16.6667 13.7389 16.9986 12.886C17.3151 12.073 17.4823 11.2055 17.4823 10.3773V10.3379C17.4823 10.2049 17.5448 10.0798 17.6539 9.99458C18.068 9.67128 18.4285 9.29071 18.7255 8.86345C18.8039 8.75064 18.6802 8.60924 18.5512 8.66429Z" fill="#BDBDBD"/></svg></div>
              <div class="share-icon linkedin icon-linkedin"><svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12.5" r="12" stroke="#BDBDBD"/><path d="M6.40918 10.1372H9.08872V18.1989H6.40918V10.1372Z" fill="#BDBDBD"/><path d="M7.76587 6.25C6.84929 6.25 6.25 6.85186 6.25 7.64294C6.25 8.41656 6.83146 9.03559 7.73067 9.03559H7.74813C8.68263 9.03559 9.26418 8.41656 9.26418 7.64294C9.24673 6.85186 8.68263 6.25 7.76587 6.25Z" fill="#BDBDBD"/><path d="M15.6658 9.94678C14.2441 9.94678 13.607 10.7281 13.2509 11.2775V10.136H10.5713V18.1977H13.2508V13.6957C13.2508 13.4547 13.2683 13.2141 13.339 13.0417C13.5327 12.5604 13.9736 12.0618 14.7139 12.0618C15.6835 12.0618 16.0713 12.8011 16.0713 13.8849V18.1977H18.7507V13.5752C18.7507 11.099 17.4287 9.94678 15.6658 9.94678Z" fill="#BDBDBD"/></svg></div>
              <div class="share-icon facebook icon-facebook"><svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12.5" r="12" stroke="#BDBDBD"/><path d="M8.96724 12.9075H10.4468V18.5484C10.4468 18.6598 10.5442 18.75 10.6645 18.75H13.1731C13.2933 18.75 13.3908 18.6598 13.3908 18.5484V12.9341H15.0916C15.2022 12.9341 15.2953 12.8572 15.3079 12.7555L15.5662 10.6788C15.5733 10.6217 15.5538 10.5645 15.5125 10.5216C15.4712 10.4787 15.4121 10.4541 15.35 10.4541H13.3909V9.15234C13.3909 8.75994 13.619 8.56094 14.0691 8.56094C14.1332 8.56094 15.35 8.56094 15.35 8.56094C15.4703 8.56094 15.5677 8.47065 15.5677 8.35933V6.4531C15.5677 6.34172 15.4703 6.25149 15.35 6.25149H13.5847C13.5722 6.25093 13.5446 6.25 13.5038 6.25C13.1975 6.25 12.1328 6.30569 11.2918 7.02222C10.3599 7.81626 10.4895 8.76697 10.5204 8.93181V10.4541H8.96721C8.84695 10.4541 8.74951 10.5443 8.74951 10.6557V12.7059C8.74954 12.8172 8.84697 12.9075 8.96724 12.9075Z" fill="#BDBDBD"/></svg></div>
            </div>
          </div>
          <div class="col-12 col-sm-12 offset-sm-0 col-md-10 offset-md-0 col-lg-5">
            <h3 class="subtitle">${post.post_title}</h3>
            <div class="content">${post.post_content}</div>
          </div>
        </div>
      </article>`;

		// Return markup.
		return markup;
  },

	updateBtn() {
		// Remove is-loading class on btn.
		this.ui.btn.classList.remove('is-loading');
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    this.ui.years[0].classList.add('is-active');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js